import React, { useEffect, useRef, useId } from 'react';
import * as d3 from 'd3';

import { SCALE } from './constants';
import { INITX, INITY } from './constants';
import { CANVASW, CANVASH } from './constants';

import { drawPleatedScreen, pleatedScreenExtraHeight, SCREEN_FRAME_WIDTH } from './lib/drawPleatedScreen';

// Pleated screen drawing - same props/sizing conventions as DrawPatioDoor so it can be
// rendered through DrawWindow (configurator, ViewDetails, ShowJsonImage / quotes).
const DrawPleatedScreen = ({ doorData = null, toLeft = 0, zoom = 1, useStyle = true }) => {
  const svgRef = useRef(null);
  // Unique pattern id: the same screen is drawn twice on the page (form + View Details)
  const patternId = `pleatedMesh-${useId().replace(/:/g, '')}`;

  useEffect(() => {
    if (!doorData?.frameData) return;

    const initX = INITX - toLeft;
    const initY = INITY;

    const totalWidth = (parseFloat(doorData.frameData.frameWidth) || 0) * SCALE;
    const totalHeight = (parseFloat(doorData.frameData.frameHeight) || 0) * SCALE;
    doorData.frameData.X = totalWidth;
    doorData.frameData.Y = totalHeight;

    const svg = initSvg(totalWidth, totalHeight);
    drawPleatedScreen(svg, doorData, initX, initY, patternId);
  }, [doorData, toLeft, zoom]);

  function initSvg(totalWidth, totalHeight) {
    d3.select(svgRef.current).selectAll('*').remove();

    const width = totalWidth ? totalWidth + INITX + 65 : CANVASW;
    const height = totalHeight
      ? totalHeight + INITY - SCREEN_FRAME_WIDTH + pleatedScreenExtraHeight()
      : CANVASH;

    const svgElement = d3
      .select(svgRef.current)
      .attr('width', width * zoom)
      .attr('height', height * zoom)
      .style('border', '0px solid black');

    return svgElement
      .append('g')
      .attr('transform', `scale(${zoom})`);
  }

  return (
    <div className="scaled-image">
      <svg ref={svgRef}></svg>
    </div>
  );
};

export default DrawPleatedScreen;
